import { BulkTableRow } from '@/components/bulkQueue/types';

export const rowToLink = (row: BulkTableRow) => {
    switch (row.__typename) {
        case 'VisitRequest':
            return `/visit-requests/${row.id}`;
        case 'Visit':
            return `/visits/${row.id}`;
        default:
            return undefined;
    }
};
